import React from 'react';
import SectionHeadingStyle2 from '../../SectionHeading/SectionHeadingStyle2';
import Certificate from '../../Certificate';
import config from '../../../config';

export default function CertificateSection({ data, sectionTitle, sectionTitleUp }) {
  return (
    <div className="container">
      {sectionTitle && (
        <SectionHeadingStyle2
          sectionTitle={sectionTitle}
          sectionTitleUp={sectionTitleUp}
        />
      )}

      <div className="row">
        {data?.map((item, index) => (
          <div className="col-lg-12" key={index}>
            <Certificate
              key={index}
              imgLink={config.baseUrl+ item.imgLink}
              name={item.name}
              description={item.description}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
